/* eslint-disable max-len */
import 'react';

const SidebarTeamSvg = (): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `SidebarTeamSvg${Date.now()}`;

    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <defs>
                <filter id={id}>
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.360784 0 0 0 0 0.392157 0 0 0 0 0.450980 0 0 0 1.000000 0"></feColorMatrix>
                </filter>
            </defs>
            <g id="页面-2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="3" transform="translate(-130.000000, -872.000000)">
                    <g id="编组-22" transform="translate(86.000000, 333.000000)">
                        <g id="编组-19备份-3" transform="translate(44.000000, 539.000000)">
                            <rect id="矩形" x="0" y="0" width="18" height="18"></rect>
                            <g id="编组-26" transform="translate(1.500000, 2.000000)" stroke="currentColor">
                                <rect id="矩形" x="5.5" y="0.5" width="4.5" height="4.5" rx="1.5"></rect>
                                <rect id="矩形备份-12" x="0.5" y="9" width="4.5" height="4.5" rx="1.5"></rect>
                                <line x1="5.25" y1="11" x2="9.75" y2="11" id="直线-2" strokeLinecap="square"></line>
                                <line x1="3.5" y1="9" x2="6" y2="4.5" id="直线-2"></line>
                                <line x1="9.5" y1="9" x2="12" y2="4.5" id="直线-2" transform="translate(10.750000, 6.750000) scale(-1, 1) translate(-10.750000, -6.750000) "></line>
                                <rect id="矩形备份-12" x="10" y="9" width="4.5" height="4.5" rx="1.5"></rect>
                            </g>
                            <g filter={`url(#${id})`} id="编组-16">
                                <g transform="translate(3.000000, 2.500000)" id="矩形"></g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default SidebarTeamSvg;
